import { getPreferencesStorageKey, PreferenceStorageKey } from '../../../shared/preferences/preferences.utils';
import { getCalendarPreferenceStorageKeyPrefix } from '../../../shared/preferences/preferences.storage';

const PREFER_WEEKENDS_VISIBLE_PREFERENCE_KEY = `${getCalendarPreferenceStorageKeyPrefix()}:preferWeekendsVisible`;

export const getWeekendsVisibilityPreferenceStorageKey = (): PreferenceStorageKey<
   typeof PREFER_WEEKENDS_VISIBLE_PREFERENCE_KEY
> => {
   return getPreferencesStorageKey(PREFER_WEEKENDS_VISIBLE_PREFERENCE_KEY);
};
